"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userApi = void 0;
const getPaginatableUsers = {
    method: "GET",
    url: "/users",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getUsersSummary = {
    method: "GET",
    url: "/users/summary",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getUser = (userId) => ({
    method: "GET",
    url: `/users/${userId}`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const createUser = {
    method: "POST",
    url: "/users",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const deleteUsers = {
    method: "DELETE",
    url: "/users",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const updateUser = (userId) => ({
    method: "PUT",
    url: `/users/${userId}`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const updateUserInitialPasswordByEmail = {
    method: "PUT",
    url: "/user/init-password",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const updateUserPasswordByEmail = {
    method: "PUT",
    url: "/users/password",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const notifyUserCreated = (userId) => ({
    method: "POST",
    url: `/users/${userId}/notify-user-created`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const checkIsPasswordConfigured = {
    method: "POST",
    url: "/user/check-is-password-configured",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const restoreUsers = {
    method: "POST",
    url: "/users/restore",
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.userApi = {
    createUser,
    deleteUsers,
    getPaginatableUsers,
    getUsersSummary,
    getUser,
    updateUser,
    updateUserInitialPasswordByEmail,
    updateUserPasswordByEmail,
    notifyUserCreated,
    checkIsPasswordConfigured,
    restoreUsers,
};
//# sourceMappingURL=user.js.map